import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

const TitleChecked = ({ firstName = '', className = '' }) => {
  if (firstName) {
    return (
      <span className={`${className}`}>
        {trans('HomeCheckerBox.verified.homechecker', {
          firstName
        })}
      </span>
    );
  }
  return (
    <span className={`${className}`}>
      {trans('listing.verification.virtual')}
    </span>
  );
};

export default TitleChecked;

TitleChecked.propTypes = {
  firstName: PropTypes.string,
  className: PropTypes.string
};
